const Toast = ({ toastMsg, isShow }) => {
  return (
    <div className={`toast-wrapper ${isShow ? 'is-show' : ''}`}>
      <p className={'toast-msg'}>{toastMsg}</p>
    </div>
  );
};

export default Toast;
